export default "__VITE_ASSET__2ozYLq98__"